module.exports = __webpack_public_path__ + "img/promotion2.cb75ad7d.png";